// 消耗品種別
export const EXPENDABLE_TYPE_MAP = {
    mask: { code: 1, name: "マスク" },
    chamber: { code: 2, name: "チェンバー" },
    hose: { code: 3, name: "ホース" }
};

// 付属品種別
export const ACCESSORY_TYPE_MAP = {
    humidifier: { code: 1, name: "加湿器" },
    modem: { code: 2, name: "モデム" }
};



// WEBPACK FOOTER //
// ./src/utils/item.js